import { Node, Nodes } from '../../types/core';
import { isText } from './isText';

export const getTextNodes = (elements: Nodes): Nodes => {
    return elements.flatMap((node: Node) => (isText(node) ? node : getTextNodes(node.children)));
};
